<template>
  <div class="core">
    <div class="layui-fluid">
      <div>
        <div class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div class="layui-inline" style="width: 170px">
            <input
              type="text"
              autocomplete="off"
              class="layui-input"
              placeholder="请输入查询条件"
              v-model="tableObj.queryObject['WORK_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2']"
            />
          </div>
          <div class="layui-inline"><label class="layui-search-label">时间段:</label></div>
          <div class="layui-inline" style="width: 195px">
            <layui-daterange
              class="dateRange"
              v-model="tableObj.queryObject.TIME_RANGE"
              @dateChange="handleDateChange($event)"
              ref="daterange"
            ></layui-daterange>
          </div>
          <button class="layui-btn layuiadmin-btn-list" title="查询" @click="search()">查 询</button>
          <button
            class="layui-btn fold-flag advanced"
            title="高级搜索"
            style="padding: 0 12px"
            @click="handleChangeAdvance"
          >
            展开高级搜索
          </button>
          <div style="float: right">
            <button class="layui-btn refresh import" title="导入">
              <span style="display: none" id="importWarpper">
                <form enctype="multipart/form-data" style="margin-top: 20px; margin-bottom: 10px">
                  <div style="margin-left: 8.33333333%">
                    <input type="file" id="file" accept=".xls,.xlsx" />
                    <div style="margin-top: 10px; padding-top: 5px">
                      <a
                        style="cursor: pointer; color: blue"
                        href="/static/template/客户服务请求信息模板(运维单).xlsx"
                        class="btn btn-default btn-xs"
                      >
                        <i class="fa fa-file-excel-o"></i> 下载模板(运维单)
                      </a>
                      <a
                        style="cursor: pointer; color: blue; padding-left: 30px"
                        href="/static/template/客户服务请求信息模板(工程单).xlsx"
                        class="btn btn-default btn-xs"
                      >
                        <i class="fa fa-file-excel-o"></i> 下载模板(工程单)
                      </a>
                    </div>
                    <font color="red" style="margin-top: 10px; display: block">
                      提示：仅允许导入“xls”或“xlsx”格式文件！
                    </font>
                  </div>
                </form>
              </span>
              导入
              <i class="layui-icon">&#xe625;</i>
            </button>
            <button class="layui-btn refresh" title="刷新列表" @click="reset()">
              <i class="layui-icon">&#xe669;</i>
              刷 新
            </button>

            <button class="layui-btn refresh batch" title="导出" style="margin-right: 10px">
              导出
              <i class="layui-icon">&#xe625;</i>
            </button>
            <layui-exportexcel ref="export"></layui-exportexcel>
            <button
              class="layui-btn"
              title="创建服务请求运维单"
              @click="addOrder('yw')"
              v-if="this.security.hasAuth('serviceRequest_addOrder')"
            >
              <i class="layui-icon">&#xe624;</i>运维单
            </button>
            <button
              class="layui-btn deep"
              title="创建服务请求工程单"
              @click="addOrder('gc')"
              v-if="this.security.hasAuth('serviceRequest_addOrder')"
            >
              <i class="layui-icon">&#xe624;</i>工程单
            </button>
          </div>
        </div>
        <advanced-query
          ref="advancedObj"
          :tableObj="tableObj"
          :advanced="searchConfig.advanced"
          v-show="advancedShow"
          @advancedQuery="handleChangeAdvance"
        ></advanced-query>
      </div>
      <div class="layui-tab layui-tab-brief">
        <ul class="layui-tab-title">
          <li :class="tab == 'yw' ? 'layui-this' : ''" @click="handleChangeTab('yw')">服务请求运维单</li>
          <li :class="tab == 'gc' ? 'layui-this' : ''" @click="handleChangeTab('gc')">服务请求工程单</li>
        </ul>
        <div class="layui-tab-content">
          <div class="layui-tab-item" :class="tab == 'yw' ? 'layui-show' : ''">
            <layui-table
              ref="workOrder_yw"
              :lazy="true"
              table-name="YW_WORK_ORDER"
              view-name="YW_WORK_ORDER_DETAIL_V1"
              :slave-tables="['YW_RETURN_VISIT', 'YW_DEVICE']"
              :renderRow="renderRow"
              :page-size="20"
              from-index="serviceRequestIndex"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :defaultCondition="{ WORK_ORDER_CATEGORY: 1, 'DELETED:10': '1' }"
              :skin="'line'"
              height="full-265"
              :sort="['YW_WORK_ORDER_CREATE_TIME:DESC']"
              @table-event-edit="edit($event.data, 'yw')"
              @table-event-more="more($event)"
              @table-event-del="delRow($event, 'yw')"
              @table-event-hf="returnVisitOrCheckAccount($event, 'hf')"
              @table-event-dz="returnVisitOrCheckAccount($event, 'dz')"
              @table-event-close="close($event, 'yw')"
              @table-event-detail="returnVisitOrCheckAccount($event, 'ck')"
              @table-event-dispatch="dispatch($event.data, 'yw')"
              @table-event-ys="accept($event.data, 'ys')"
            >
              <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <layui-tableconfig :config="tableList_yw"></layui-tableconfig>
                <div rowspan="3" align="left" fixed="right" title="操作" width="146">
                  <script type="text/html" v-pre>
                    <i class="layui-icon t_check_a operate_table" lay-event="detail" title="查看"></i>
                    <!--   11.待接单 12.待预约 13.待签到 14.待自检 15.待内部验收 16.待签退  都可以派单  【一单多派】 如果要合并状态，只显示【现场处理】，只需要改前端这个字段得显示，不需要改后台对应的状态id-->
                    <!-- 2022.12.1  加上  17：已完成  也可以派单-->
                    {{# if(
                    (d.ORDER_STATE === '1' && d.WORK_ORDER_METHOD === '1' &&d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE ==='2' && d.WORK_ORDER_METHOD === '1' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '3' && d.WORK_ORDER_METHOD === '3' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '11' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '12' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '13' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '14' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '15' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '16' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '17' && d.WORK_ORDER_METHOD !== '2' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '1' && d.WORK_ORDER_METHOD === '3' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10') ||
                    (d.ORDER_STATE === '2' && d.WORK_ORDER_METHOD === '3' && d._mark.indexOf('serviceOrder_dispatch') > -1 && d.REPAIR_STATUS_ID !== '10')) { }}
                    <i class="layui-icon t_pd_a operate_table" lay-event="dispatch" title="派单"></i>

                    {{# } }} {{# if(d._mark.indexOf("serviceOrder_edit") > -1){ }}
                    <i class="layui-icon t_edit_a operate_table" lay-event="edit" title="编辑"></i>

                    {{# } }} {{# if(d.ORDER_STATE==='4' && d._mark.indexOf("serviceOrder_hf") > -1){ }}
                    <i class="layui-icon t_hf_a operate_table" lay-event="hf" title="回访"></i>

                    {{# } }} {{# if(d.ORDER_STATE==='5' && d._mark.indexOf("serviceOrder_dz") > -1){ }}
                    <i class="layui-icon t_dz_a operate_table" lay-event="dz" title="对账付款"></i>

                    {{# } }} {{# if((d.CHECK_FINISH==='1' && d.REPAIR_STATUS_ID === "") || (d.CHECK_FINISH==='1' &&
                    d.REPAIR_STATUS_ID === '7')){ }}
                    <i class="layui-icon t_close_a operate_table" lay-event="close" title="关闭"></i>

                    {{# } }} {{# if(d._mark.indexOf("serviceOrder_del") > -1){ }}
                    <i class="layui-icon t_del_a operate_table" lay-event="del" title="删除"></i>

                    <!--  点击待验收按钮后，报修单状态为【6：待验收】  work_order repair_status_id=6     d.ORDER_STATE === '17'【已完成】-->
                    {{# } }} {{# if(d.CHECK_FINISH==='1' && d.ORDER_STATE === '17' && d.REPAIR_STATUS_ID !== "" &&
                    d.REPAIR_STATUS_ID !== '7'){ }}
                    <i class="layui-icon t_ys_a operate_table" lay-event="ys" title="待验收"></i>
                    {{# } }}
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'gc' ? 'layui-show' : ''">
            <layui-table
              ref="workOrder_gc"
              :lazy="true"
              table-name="YW_WORK_ORDER"
              view-name="YW_WORK_ORDER_DETAIL_V1"
              :slave-tables="['YW_RETURN_VISIT', 'YW_DEVICE']"
              :renderRow="renderRow"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :defaultCondition="{ WORK_ORDER_CATEGORY: 2, 'DELETED:10': '1' }"
              :skin="'line'"
              height="full-265"
              :sort="['YW_WORK_ORDER_CREATE_TIME:DESC']"
              @table-event-edit="edit($event.data, 'gc')"
              @table-event-del="delRow($event, 'gc')"
              @table-event-detail="returnVisitOrCheckAccount($event, 'ck')"
              @table-event-dispatch="dispatch($event.data, 'gc')"
              @table-event-close="close($event, 'gc')"
              @table-event-hf="returnVisitOrCheckAccount($event, 'hf')"
              @table-event-dz="returnVisitOrCheckAccount($event, 'dz')"
            >
              <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <layui-tableconfig :config="tableList_gc"></layui-tableconfig>
                <div rowspan="3" align="center" fixed="right" title="操作" width="146">
                  <script type="text/html" v-pre>
                    <i class="layui-icon t_check_a operate_table" lay-event="detail" title="查看"></i>
                    {{# if((d.ORDER_STATE.indexOf('1') > -1 && d.WORK_ORDER_METHOD==='1' &&
                    d._mark.indexOf("serviceOrder_dispatch") > -1) || d.ORDER_STATE==='2' && d.WORK_ORDER_METHOD==='1'
                    && d._mark.indexOf("serviceOrder_dispatch") > -1 || d.ORDER_STATE==='3' && d.WORK_ORDER_METHOD==='1'
                    && d._mark.indexOf("serviceOrder_dispatch") > -1){ }}
                    <i class="layui-icon t_pd_a operate_table" lay-event="dispatch" title="派单"></i>
                    {{# } }} {{# if(d._mark.indexOf("serviceOrder_edit") > -1){ }}
                    <i class="layui-icon t_edit_a operate_table" lay-event="edit" title="编辑"></i>
                    {{# } }} {{# if(d.ORDER_STATE==='4' && d._mark.indexOf("serviceOrder_hf") > -1){ }}
                    <i class="layui-icon t_hf_a operate_table" lay-event="hf" title="回访"></i>
                    {{# } }} {{# if(d.ORDER_STATE==='5' && d._mark.indexOf("serviceOrder_dz") > -1){ }}
                    <i class="layui-icon t_dz_a operate_table" lay-event="dz" title="对账付款"></i>
                    {{# } }} {{# if(d._mark.indexOf("serviceOrder_del") > -1){ }}
                    <i class="layui-icon t_del_a operate_table" lay-event="del" title="删除"></i>
                    {{# } }} {{# if(d.CHECK_FINISH==='1' ){ }}
                    <i class="layui-icon t_close_a operate_table" lay-event="close" title="关闭"></i>
                    {{# } }}
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
        </div>
      </div>
    </div>
    <service-request-form v-if="operation" :visible.sync="operation" :formData="formData" :orderType="orderType" />
  </div>
</template>
<script>
import '../../../utils/map/css/core.css'
import serviceRequestForm from './serviceRequestForm'
import request from '@/network/networkconfig'
export default {
  components: {
    serviceRequestForm,
  },
  data() {
    return {
      tab: 'yw',
      tableList_yw: [
        { field: 'ORDER_STATE_DESC', title: '状态', sort: true, width: 90 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
        { field: 'BILL_SOURCE_METHOD_DESC', title: '服务请求单来源' },
        { field: 'CLIENT_NAME', title: '客户' },
        { field: 'BRAND_NAME', title: '品牌' },
        { field: 'STORE_NAME', title: '门店' },
        { field: 'MANAGER_NAME', title: '项目经理' },
        // { field: 'SERVICE_NAME', title: '服务商', width: 200  },
        { field: 'WORK_ORDER_TYPE_DESC', title: '服务请求单类型' },
        { field: 'SLA_LEVEL', title: 'SLA等级', width: 100 },
        { field: 'WORK_ORDER_METHOD_DESC', title: '服务方式', width: 100 },
        { field: 'YW_WORK_ORDER_CREATE_TIME', title: '创建时间', sort: true, width: 160 },
      ],
      tableList_gc: [
        { field: 'ORDER_STATE_DESC', title: '状态', sort: true },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
        { field: 'CLIENT_NAME', title: '客户' },
        { field: 'BRAND_NAME', title: '品牌' },
        { field: 'STORE_NAME', title: '门店' },
        { field: 'MANAGER_NAME', title: '项目经理' },
        // { field: 'SERVICE_NAME', title: '服务商', width: 200 },
        { field: 'WORK_ORDER_TYPE_DESC', title: '服务请求单类型' },
        // { field: 'SLA_LEVEL', title: 'SLA等级', width: 90},
        { field: 'WORK_ORDER_METHOD_DESC', title: '服务方式' },
        { field: 'YW_WORK_ORDER_CREATE_TIME', title: '创建时间', sort: true },
      ],
      operation: false,
      workOrder: false,
      tableObj: {
        fromIndex: 'serviceRequestIndex',
        checkedRows: 0,
        queryObject: {},
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'WORK_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2',
            PLACEHOLDER: '请输入查询条件',
          },
          {
            TYPE: 'daterange',
            FIELD: 'TIME_RANGE',
            NAME: '时间段',
            REF: 'daterange',
            WIDTH: '200px',
            handleDateChange: 'handleDateChange($event)',
          },
        ],
        advanced: [
          { TYPE: 'input', NAME: '服务请求单编号 :', FIELD: 'WORK_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '客户 :', FIELD: 'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '品牌 :', FIELD: 'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '门店 :', FIELD: 'STORE_NAME:2', PLACEHOLDER: '请输入查询条件' },
          {
            TYPE: 'layui-multiselect',
            NAME: '服务请求单类型:',
            FIELD: 'WORK_ORDER_TYPE:1',
            textField: 'DIC_NAME',
            valueField: 'DIC_CODE',
            tableName: 'DB_DICTIONARY',
            idField: 'ID',
            parentField: 'DIC_PCODE',
            queryCondition: { DIC_CATEGORY: '工单类型', 'JB:5': '2' },
          },
          { TYPE: 'input', NAME: '项目经理 :', FIELD: 'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件' },
          {
            TYPE: 'layui-multiselect',
            NAME: '状态:',
            FIELD: 'ORDER_STATE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('ORDER_STATE'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: 'SLA等级:',
            FIELD: 'SLA_LEVEL:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('SLA_LEVEL'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '服务方式:',
            FIELD: 'WORK_ORDER_METHOD:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('WORK_ORDER_METHOD'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '服务请求单来源:',
            FIELD: 'BILL_SOURCE_METHOD:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('BILL_SOURCE_METHOD'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '收入费用状态',
            FIELD: 'INCOME_AMOUNT_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('INCOME_AMOUNT_TYPE'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '收入票据状态',
            FIELD: 'INCOME_BILL_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('INCOME_BILL_TYPE'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '支出费用状态',
            FIELD: 'EXPENSES_AMOUNT_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('EXPENSES_AMOUNT_TYPE'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '支出票据状态',
            FIELD: 'EXPENSES_BILL_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('EXPENSES_BILL_TYPE'),
          },
        ],
      },
      moreBtn: [
        { title: '回访', id: '1' },
        { title: '关闭', id: '2' },
        { title: '删除', id: '3' },
        { title: '查看记录', id: '4' },
      ],
      orderType: '',
      formData: {},
      exportTemplate: '客户服务请求表.xlsx',
      relationExportTemplate: '客户服务请求关联表.xlsx',
      advancedShow: false,
    }
  },
  mounted() {
    //$(".dateRange").find(".layui-icon-date").css('top', '-2px');
    this.tableObj_yw = this.$refs.workOrder_yw
    this.tableObj_gc = this.$refs.workOrder_gc
    this.tableObj = this.tableObj_yw
    if (this.tabParam) {
      if ((this.tabParam.source = 'viewBoard')) {
        this.requestUniqueId = this.tabParam.requestUniqueId
        this.tableObj_yw.requestUniqueId = this.tabParam.requestUniqueId
        this.tableObj_gc.requestUniqueId = this.tabParam.requestUniqueId
        if (this.tabParam.title == '本周总服务请求') {
          this.api.getServerWeekRange().then((time) => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.title == '本月总服务请求') {
          this.api.getServerMonthRange().then((time) => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.title == '上周总服务请求') {
          this.api.getServerLastWeekRange().then((time) => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.condition) {
          //TODO 赋值查询条件输入框
          this.$set(this.$refs.advancedObj, 'queryObject', this.tabParam.condition)
          this.tableObj_yw.queryObject = { ...this.tableObj.queryObject, ...this.tabParam.condition }
          this.tableObj_gc.queryObject = { ...this.tableObj.queryObject, ...this.tabParam.condition }
          this.tableObj_yw.load()
        } else {
          this.tableObj_yw.load()
        }
      }
    } else {
      this.tableObj_yw.load()
    }
    // 导入
    var importId = this.uuid()
    var that = this
    var element = (this.el = $(this.$el))
    var importEl = element.find('.import')
    importEl.attr('id', importId)

    this.layui.dropdown.render({
      elem: '#' + importId,
      data: [
        { title: '导入工程单', id: 1 },
        { title: '导入运维单', id: 2 },
      ],
      click: function (obj) {
        if (obj.id == 1) {
          that.importWorkOrderData(obj.id)
        } else if (obj.id == 2) {
          that.importWorkOrderData(obj.id)
        }
      },
    })

    //导出
    var batchId = this.uuid()
    var that = this
    var element = (this.el = $(this.$el))
    var batchEl = element.find('.batch')
    batchEl.attr('id', batchId)
    this.layui.dropdown.render({
      elem: '#' + batchId,
      data: [
        { title: '普通导出', id: 1 },
        { title: '关联导出', id: 2 },
      ],
      click: function (obj) {
        if (obj.id == 1) {
          that.exportExcel()
        } else if (obj.id == 2) {
          that.relationExportExcel()
        }
      },
    })
    //监听派单保存成功后刷新
    this.$bus.$on('dispatchForm', () => {
      this.dispatchForm = true
    })
  },
  activated() {
    if (this.dispatchForm) {
      this.dispatchForm = false
      this.tableObj_yw.load()
      this.tableObj_gc.load()
    }
  },
  methods: {
    importWorkOrderData(importType) {
      let that = this

      let url
      if (importType === 2) {
        url = process.env.API_HOST + '/newData/import/work_order_yw?token=' + that.security.getToken()
      } else {
        url = process.env.API_HOST + '/newData/import/work_order_gc?token=' + that.security.getToken()
      }

      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function (index, layero) {
          var file = layero.find('#file').val()
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))) {
            that.layer.openAlert('请选择后缀为 “xls”或“xlsx”的文件。')
            return false
          }
          var index = layer.load(2, { shade: false })
          var formData = new FormData()
          formData.append('file', layero.find('#file')[0].files[0])
          $.ajax({
            url: url,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function (result) {
              layer.closeAll()
              if (result.errorMsg) {
                that.layer.openAlert(result.errorMsg)
                return
              }
              result = result.result
              layer.close(index)
              if (result != '') {
                that.$nextTick(() => {
                  that.tableObj.load()
                })
              }
            },
            error: function (err) {
              layer.close(index)
            },
          })
        },
      })
    },
    // 关闭操作
    // todo 关闭前，先看是不是报修单，如果是报修单，状态不是验收通过，就不让关闭
    close(data, type) {
      this.layer.openConfirm('确定要关闭吗？', () => {
        request({
          url: process.env.API_HOST + '/serviceOrder/close/' + data.data.WORK_ORDER_ID,
          method: 'get',
        }).then(
          (res) => {
            if (res.result.errorMsg) {
              this.layer.openAlert(res.result.errorMsg)
            } else {
              this.layer.openSuccess('关闭成功!', { targetEl: $('body') })
              this.tableObj_yw.load()
              this.tableObj_gc.load()
            }
          },
          null,
          { targetEl: $('body') }
        )
      })
    },

    /**
     * tabs改变事件
     */
    handleChangeTab(type) {
      if (this.tab != type) {
        if (type == 'yw') {
          this.tableObj_yw.queryObject = this.tableObj.queryObject
          this.tableObj_yw.load()
          this.tableObj = this.tableObj_yw
        } else {
          this.tableObj_gc.queryObject = this.tableObj.queryObject
          this.tableObj_gc.load()
          this.tableObj = this.tableObj_gc
        }
      }
      this.tab = type
    },
    handleChangeAdvance() {
      this.advancedShow = !this.advancedShow
      $('.advanced').html(this.advancedShow ? '收起高级搜索' : '展开高级搜索')
    },
    //逻辑删除
    delRow($event, orderType) {
      var remind = ''
      var rows = $event.data
      if (rows.ORDER_STATE != 1 && rows.WORK_ORDER_METHOD == 1) {
        remind = '该服务请求单已派单，'
      }
      if (!Array.isArray(rows)) {
        rows = [rows]
      }
      this.layer.openConfirm(remind + '确定要删除这<span style="color:red">' + rows.length + '</span>条记录吗?', () => {
        rows = rows.map((row) => {
          row.DELETED = '1'
          row.IS_NEW = false
          return row
        })
        let req = this.api.saveList('YW_WORK_ORDER', rows, 'delWorkOrder')
        req.then((response) => {
          if (response.errorMsg) {
            this.layer.openAlert(response.errorMsg, false)
          } else {
            if (orderType == 'yw') {
              this.tableObj_yw.load()
            } else {
              this.tableObj_gc.load()
            }
            if (remind) {
              this.$bus.$emit('delWordOrder') //刷新现场服务单
            }
            this.layer.openSuccess('删除成功!')
          }
        })
      })
    },
    /**
     * 新增工单
     */
    addOrder(orderType) {
      if (orderType == 'yw') {
        this.baseComponent.smartLoadComponent('serviceRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj_yw,
          type: 'yw',
          title: '创建服务请求运维单',
          form_type: 'add',
        })
      } else {
        this.baseComponent.smartLoadComponent('serviceRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj_gc,
          type: 'gc',
          title: '创建服务请求工程单',
        })
      }
    },
    edit(data, orderType) {
      //查询子表
      var p2 = {}
      p2['WORK_ORDER_ID'] = data['WORK_ORDER_ID']
      var slaveTables = 'YW_RETURN_VISIT,YW_DEVICE'
      var requestId = 'workOrder_querySlaveTables'
      this.api.queryList('YW_WORK_ORDER', { p2: p2, p8: slaveTables }, requestId).then((response) => {
        var result = response.result
        if (result) {
          data = result[0]
          if (orderType == 'yw') {
            this.baseComponent.smartLoadComponent('serviceRequestForm', {
              serviceRequest: this,
              editRow: data,
              tableObj: this.tableObj_yw,
              type: 'yw',
              title: '编辑服务请求运维单',
              requestUniqueId: 'editWorkOrder',
            })
          } else {
            this.baseComponent.smartLoadComponent('serviceRequestForm', {
              serviceRequest: this,
              editRow: data,
              tableObj: this.tableObj_gc,
              type: 'gc',
              title: '编辑服务请求工程单',
              requestUniqueId: 'editWorkOrder',
            })
          }
        }
      })
    },
    //回访
    returnVisitOrCheckAccount(params, orderType) {
      //TODO 一个工单对应多个服务单
      var p2 = {}
      p2['F_WORK_ORDER_ID'] = params.data['WORK_ORDER_ID']
      var requestId = 'queryServiceOrderTables'
      this.api.queryList('YW_SERVICE_ORDER_V1', { p2: p2 }, requestId).then((response) => {
        var result = response.result
        if (result) {
          params.data['YW_SERVICE_ORDER_V1'] = result
          var title = ''
          if (orderType == 'ck') {
            title = '服务请求详情'
          }
          if (orderType === 'hf') {
            title = '客户回访'
          }
          if (orderType === 'dz') {
            title = '对账付款'
          }
          var componentName = 'serviceRequestDetailForm-' + params.data['WORK_ORDER_NUM']
          if (params.data.WORK_ORDER_CATEGORY == '1') {
            this.baseComponent.smartLoadComponent(
              'serviceRequestDetailForm',
              {
                title: title + '-' + params.data['WORK_ORDER_NUM'],
                source: 'workOrder',
                formData: params.data,
                orderType: orderType,
                tableObj: this.tableObj_yw,
              },
              { uniqueName: componentName }
            )
          } else {
            this.baseComponent.smartLoadComponent(
              'serviceRequestDetailForm',
              {
                title: title + '-' + params.data['WORK_ORDER_NUM'],
                source: 'workOrder',
                formData: params.data,
                orderType: orderType,
                tableObj: this.tableObj_gc,
              },
              { uniqueName: componentName }
            )
          }
        }
      })
    },
    //验收
    accept(data, orderType) {
      // 每次点击待验收按钮，先查询该报修单是否是待验收状态
      request({
        url: process.env.API_HOST + '/serviceOrder/queryWorkOrderStatus/' + data.WORK_ORDER_ID,
        method: 'get',
      }).then(
        (result) => {
          if (result.result.errorMsg) {
            this.layer.openAlert(result.result.errorMsg)
          } else {
            if (result.result.REPAIR_STATUS_ID === '6') {
              this.layer.openSuccess('已通知店长验收,请勿重复提交', { targetEl: $('body') })
            } else {
              this.layer.openConfirm('确定提醒店长验收吗？', () => {
                request({
                  url: process.env.API_HOST + '/serviceOrder/accept/' + data.WORK_ORDER_ID,
                  method: 'get',
                }).then(
                  (res) => {
                    if (res.result.errorMsg) {
                      this.layer.openAlert(res.result.errorMsg)
                    } else {
                      this.layer.openSuccess('已通知店长验收!', { targetEl: $('body') })
                      this.tableObj_yw.load()
                      this.tableObj_gc.load()
                    }
                  },
                  null,
                  { targetEl: $('body') }
                )
              })
            }
          }
        },
        null,
        { targetEl: $('body') }
      )
    },
    //派单
    dispatch(data, orderType) {
      data.F_WORK_ORDER_ID = data.WORK_ORDER_ID
      data.DISPATCH = 'true' //派单
      data.IS_NEW = true
      if (orderType == 'yw') {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj,
          editRow: data,
          type: 'yw',
          title: '创建现场服务运维单',
          from: 'dispatchForm',
          input_disabled: true,
        })
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj,
          editRow: data,
          type: 'gc',
          title: '创建现场服务工程单',
          from: 'dispatchForm',
          input_disabled: true,
        })
      }
    },
    //导出
    exportExcel() {
      let tableObj = {}
      tableObj.tableName = 'YW_WORK_ORDER_DETAIL_V1'
      tableObj.queryObject = JSON.parse(JSON.stringify(this.tableObj.queryObject));
      tableObj.sort = ['STORE_NAME:ASC', 'WORK_ORDER_NUM:ASC', 'YW_WORK_ORDER_CREATE_TIME:DESC']
      var exportObj = this.$refs.export
      exportObj.requestUniqueId = this.requestUniqueId
      exportObj.setTemplateName(this.exportTemplate)
      if (this.tab == 'yw') {
        tableObj.queryObject.WORK_ORDER_CATEGORY = 1;
      } else {
        tableObj.queryObject.WORK_ORDER_CATEGORY = 2;
      }
      exportObj.export(tableObj)
    },
    //关联导出 firstCol需要合并的首列，lastCol需要合并的最后一列 keyWord判断相等需要合并的关键词
    relationExportExcel() {
      let tableObj = {}
      tableObj.tableName = 'yw_service_order_v1'
      tableObj.queryObject = JSON.parse(JSON.stringify(this.tableObj.queryObject));
      tableObj.sort = ['STORE_NAME:ASC', 'WORK_ORDER_NUM:ASC', 'YW_WORK_ORDER_CREATE_TIME:DESC']
      tableObj.firstCol = '0'
      tableObj.lastCol = '20'
      tableObj.keyWord = 'SERVICE_ORDER_NUM';
      if (this.tab == 'yw') {
        tableObj.queryObject.WORK_ORDER_CATEGORY = 1;
      } else {
        tableObj.queryObject.WORK_ORDER_CATEGORY = 2;
      }
      let startTime = tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5'];
      let endTime = tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6'];
      delete tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5'];
      delete tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6'];
      tableObj.queryObject['YW_SERVICE_ORDER_CREATE_TIME:5'] = startTime;
      tableObj.queryObject['YW_SERVICE_ORDER_CREATE_TIME:6'] = endTime;
      console.log(tableObj.queryObject);
      var exportObj = this.$refs.export
      exportObj.requestUniqueId = this.requestUniqueId
      exportObj.setTemplateName(this.relationExportTemplate)
      exportObj.export(tableObj)
    },
    search() {
      if (this.tab == 'yw') {
        this.tableObj_yw.queryObject = this.tableObj.queryObject
        this.tableObj_yw.load()
      } else {
        this.tableObj_gc.queryObject = this.tableObj.queryObject
        this.tableObj_gc.load()
      }
    },
    reset() {
      this.advancedShow = false
      this.$refs.advancedObj.clear()
      this.tableObj.queryObject = {}
      this.tableObj_yw.queryObject = {}
      this.tableObj_gc.queryObject = {}
      if (this.tab == 'yw') {
        this.tableObj_yw.load()
      } else {
        this.tableObj_gc.load()
      }
    },
    more(params) {
      this.layui.dropdown.render({
        elem: params.el,
        data: this.moreBtn,
        click: function (data, othis) {
          var elem = $(this.elem),
            listId = elem.data('id') //表格列表的预埋数据
          layer.msg('得到表格列表的 id：' + listId + '，下拉菜单 id：' + data.id)
        },
      })
      $(params.el).click()
    },
    renderRow(data) {
      //1.客服处理  2.现场处理 3.内部验收  4.服务回访 5.对账付款 6.已关闭
      // todo ORDER_STATE in (11,12,13,14,15,16,17,18) 统称为 【现场处理】  2022.9.7
      // todo  高级查询 去掉 (11,12,13,14,15,16,17,18)   查询【现场处理：2】  将查询条件改为  ORDER_STATE in (11,12,13,14,15,16,17,18)
      if (data.ORDER_STATE == 1) {
        data.ORDER_STATE_DESC = '客服处理'
      } else if (data.ORDER_STATE == 2) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 3) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 4) {
        data.ORDER_STATE_DESC = '服务回访'
      } else if (data.ORDER_STATE == 5) {
        data.ORDER_STATE_DESC = '对账付款'
      } else if (data.ORDER_STATE == 6) {
        data.ORDER_STATE_DESC = '已关闭'
      } else if (data.ORDER_STATE == 10) {
        data.ORDER_STATE_DESC = '草稿'
      } else if (data.ORDER_STATE == 11) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 12) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 13) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 14) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 15) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 16) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 17) {
        data.ORDER_STATE_DESC = '现场处理'
      } else if (data.ORDER_STATE == 18) {
        data.ORDER_STATE_DESC = '现场处理'
      }
      data.CHECK_FINISH = data.CHECK_FINISH + ''
    },
    handleDateChange(daterange) {
      this.tableObj.queryObject.TIME_RANGE = daterange
      var range = daterange.split(' - ')
      var startTime = range[0]
      var endTime = range[1]
      this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5'] = startTime
      this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6'] = endTime + ' 23:59:59'
    },
  },
}
</script>
<style scoped>
.layui-inline >>> .layui-icon-date {
  top: -2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/serviceRequest/index.vue